import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const favoriteCourses = [
  { id: 1, name: 'Torrey Pines', type: 'Public', location: 'San Diego, CA'},
  { id: 2, name: 'Pebble Beach', type: 'Private', location: 'Pebble Beach, CA' },
  { id: 3, name: 'St. Andrews', type: 'Public', location: 'St. Andrews, Scotland' }
];

const FavoritesPage = () => {
  return (
    <Container className="mt-4">
      <Row>
        {/* Main Content */}
        <Col md={9}>
          <h2 className="mb-4">Favorite Courses</h2>
          {favoriteCourses.map((course) => (
            <Card key={course.id} className="mb-3 p-3 d-flex flex-row align-items-center hover-grow shadow border-0">
              <Card.Img 
                variant="left" 
                src={course.image || '/images/golf flag.png'} 
                style={{ width: '80px', height: '80px', borderRadius: '8px', objectFit: 'cover' }} 
              />
              <Card.Body>
                <Card.Title>{course.name} <span className="text-warning">★</span></Card.Title>
                <Card.Text>
                  {course.type} | {course.location}
                </Card.Text>
              </Card.Body>
              <Button variant="outline-secondary" className="ms-auto">Remove</Button>
            </Card>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default FavoritesPage;